import { toast } from 'react-toastify';
import API from '../apiClient';

export const createOrganization = (payload) => {
    return new Promise((resolve,reject) => {
        API.post(`/organization`, payload)
        .then(response => {
            resolve(response);
        }).catch(error =>{
            reject(error);
            console.log(error)
          });
    })

}

export const UpdateOrganization = (entity,payload) => {
    return new Promise((resolve,reject) => {
        API.put(`/organization/${encodeURIComponent(entity)}`, payload)
        .then(response => {
            resolve(response);
        }).catch(error =>{
            reject(error);
            console.log(error)
          });
    })

}

export const GetAvailableIndustries = (organizationID) => {
    return new Promise((resolve, reject) => {
        API.get(`/organization/${encodeURIComponent(organizationID)}/available-industries`)
        .then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
            console.log(error);
        });
    });
}